
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"53","height":"53","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.342 1.656H4.658A4.663 4.663 0 000 6.314V37.37a4.663 4.663 0 004.658 4.658H9.42v7.764a1.553 1.553 0 002.65 1.098l8.862-8.862h27.41A4.663 4.663 0 0053 37.37V6.314a4.664 4.664 0 00-4.658-4.658zm1.553 35.713c0 .856-.697 1.553-1.553 1.553H20.289c-.412 0-.807.164-1.098.455l-6.666 6.665v-5.567c0-.858-.695-1.553-1.552-1.553H4.658a1.555 1.555 0 01-1.553-1.553V6.314c0-.856.697-1.552 1.553-1.552h43.684c.856 0 1.553.696 1.553 1.552V37.37z","fill":"#F04D4D"}}),_c('path',{attrs:{"d":"M26.5 7.867c-7.706 0-13.975 6.27-13.975 13.975s6.27 13.974 13.975 13.974c7.706 0 13.975-6.269 13.975-13.974 0-7.706-6.27-13.975-13.975-13.975zm0 24.844c-5.993 0-10.87-4.876-10.87-10.87 0-5.992 4.877-10.868 10.87-10.868 5.993 0 10.87 4.876 10.87 10.869 0 5.993-4.877 10.869-10.87 10.869z","fill":"#F04D4D"}}),_c('path',{attrs:{"d":"M31.99 25.4a7.71 7.71 0 00-5.49-2.272 7.712 7.712 0 00-5.49 2.272 1.553 1.553 0 002.196 2.196 4.627 4.627 0 013.294-1.362c1.246 0 2.416.483 3.294 1.361a1.553 1.553 0 102.195-2.195zM21.842 20.29a1.553 1.553 0 100-3.106 1.553 1.553 0 000 3.105zM31.158 20.29a1.553 1.553 0 100-3.106 1.553 1.553 0 000 3.105z","fill":"#F04D4D"}})])
          )
        }
      }
    